export  const PERSON_TYPE={
    person:'PERSON',
    organization:'ORGANIZATION'
}

export  const INSURANCE_OBJECT_TYPES={
    BORROWER:'BORROWER',
    VEHICLE:'VEHICLE',
    PROPERTY:'PROPERTY',
    AGRICULTURE:'AGRICULTURE',
    GTKOBJECT:'GTKOBJECT',
    OTHEROBJECT:'OTHEROBJECT ',
    CREDIT:'CREDIT',
    // SMROBJECT:'SMROBJECT',
    // OPOOBJECT:'OPOOBJECT',
    // REALESTATE:'REALESTATE',
}
